module.exports = __webpack_public_path__ + "img/teamwork-icon-13.58438cd1.png";